import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginService } from '../../features/auth/login.service';

@Injectable({
  providedIn: 'root',
})
export class ResultService {
  constructor(private http: HttpClient) {}
  baseUrl: string = environment.baseUrl;

  getAllResults(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/result/getresults`, payload);
  }

  getCurrentMonthResult(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/result/getcurrentmonthresult`, payload);
  }

  createResult(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/result/createresult`, payload);
  }

  updateResult(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/result/updateresult`, payload);
  }

  deleteResult(id: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/result/deleteresult`, { id });
  }
}
